<div class="winols-card">
  <header class="card-head">
    <div class="title-block">
      <h3>WinOLS Transactions</h3>
      <p>Transaction breakdown across statuses</p>
    </div>
    <div class="total-block">
      <span class="total-num">{{ total() | number }}</span>
    </div>
  </header>

  <ng-container *ngIf="!isLoading() && total() > 0">
    <!-- Stacked horizontal bar -->
    <div class="stacked-bar">
      <button *ngFor="let seg of segments()" type="button"
           class="bar-seg"
           [attr.aria-label]="seg.label + ': ' + seg.count + ' transactions'"
           [disabled]="seg.count === 0"
           [attr.title]="'View ' + seg.label + ' transactions'"
           (click)="openTransactions(seg.status)"
           [style.flex-grow]="seg.count"
           [style.background]="seg.color"
           [class.hidden]="seg.count === 0">
        <span class="seg-pct" *ngIf="segmentPct(seg.count) >= 8">{{ segmentPct(seg.count) }}%</span>
      </button>
    </div>

    <!-- Legend -->
    <div class="legend">
      <button class="legend-item" type="button" *ngFor="let seg of segments()"
              [attr.aria-label]="seg.count > 0 ? 'View ' + seg.label + ' transactions (' + seg.count + ')' : seg.label + ': no transactions in this period'"
              [disabled]="seg.count === 0"
              (click)="openTransactions(seg.status)">
        <span class="legend-dot" [style.background]="seg.color"></span>
        <span class="legend-label">{{ seg.label }}</span>
        <span class="legend-count">{{ seg.count | number }}</span>
      </button>
    </div>
  </ng-container>

  <div class="empty-state" *ngIf="!isLoading() && total() === 0">
    <i class="bi bi-bar-chart"></i>
    <p>No transactions in this period</p>
  </div>

  <div class="loading-state" *ngIf="isLoading()">
    <div class="bar-skeleton"></div>
    <div class="legend-skeleton">
      <div class="legend-skel" *ngFor="let _ of [1,2,3,4,5]"></div>
    </div>
  </div>
</div>
